import React from 'react'
import StepperButton from './stepper-button'

export function QuantityPicker({
  hitMaximumsByAge,
  item,
  minimums,
  stopDecrement,
  stopIncrement,
  noVacancy,
  productName,
  step,
  ticket,
  onChange
}) {
  const id = `quantity-stepper-${ticket.id}`

  return (
    <div className="flex items-center justify-start md:justify-center">
      <StepperButton
        delta={-1}
        hitMaximumsByAge={hitMaximumsByAge}
        item={item}
        minimums={minimums}
        stopDecrement={stopDecrement}
        stopIncrement={stopIncrement}
        noVacancy={noVacancy}
        step={step}
        ticket={ticket}
        updateItem={onChange}
        controls={id}
      >
        <span aria-hidden="true">-</span>
        <span className="sr-only">
          decrease {productName} quantity to {Math.max(0, ticket.quantity - 1)}
        </span>
      </StepperButton>

      <span
        className="stepper"
        id={id}
      >
        <span className="sr-only">{productName} quantity is</span>
        <span className="stepper-quantity">{ticket.quantity}</span>
      </span>

      <StepperButton
        delta={1}
        hitMaximumsByAge={hitMaximumsByAge}
        item={item}
        minimums={minimums}
        stopDecrement={stopDecrement}
        stopIncrement={stopIncrement}
        noVacancy={noVacancy}
        step={step}
        ticket={ticket}
        updateItem={onChange}
        controls={id}
      >
        <span aria-hidden="true">+</span>
        <span className="sr-only">
          increase {productName} quantity to {ticket.quantity + 1}
        </span>
      </StepperButton>
    </div>
  )
}
